export default __webpack_public_path__ + "static/media/star_6.7a160c6b.svg";